import '@/assets/vendor.scss'
import '@/assets/main.scss'
import '@/assets/tailwind.scss'

//console.warn = () => {};
import 'core-js/es/object';
import 'core-js/es/array';

import EventEmitter from 'eventemitter3';
import { sync } from 'vuex-router-sync';
import Vue from 'vue';
import Vuex from 'vuex'
import VueMeta from 'vue-meta';
import VueRouter from 'vue-router'
import App from '@ui/pages/App.vue';
import { Hub, I18n, Logger } from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';
import { ObserveVisibility } from 'vue-observe-visibility'
import { createRouter } from './router/index.js';
import { createStore } from './store/index.js';
import VueGtag from "vue-gtag";
import gql from 'graphql-tag';
import {addItemQuery, todoItemsQuery, getPostDraftsQuery, savePostDraftQuery, getLocalMemes, deleteLocalMeme } from '@/gql/Queries.js';
import ana from './ana.js';

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueMeta)
Vue.use(VueApollo);

/*
Vue.use(VueMeta, {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true
})
*/

Vue.directive('observe-visibility', ObserveVisibility)

import PortalVue from 'portal-vue';
Vue.use(PortalVue);

import InfiniteLoading from 'vue-infinite-loading';
Vue.use(InfiniteLoading, {
  slots:{
    noMore: 'You reached the end.',
    noResults: ''
  }
});

import VueResize from 'vue-resize'
Vue.use(VueResize)

const VhcheckPlugin = {
  install(Vue, options) {
    Vue.prototype.$vhcheck = new EventEmitter();
  }
}
Vue.use(VhcheckPlugin);

// OUR BUILTIN COMPONENTS
import PbcButton from '@ui/atoms/PbcButton.vue';
import PbcConfirmation from '@ui/molecules/PbcConfirmation.vue';
import PbcPopup from '@ui/molecules/PbcPopup.vue';
import PbcError from '@ui/molecules/PbcError.vue';
import PbcPanel from '@ui/atoms/PbcPanel.vue';
import PbcToggleButton from '@ui/atoms/PbcToggleButton.vue';
import ToggleSwitch from '@ui/atoms/ToggleSwitch.vue';
import PbcModal from '@ui/molecules/PbcModal.vue';
import PbcOverlay from '@ui/molecules/PbcOverlay.vue';
import Loading from '@ui/atoms/Loading.vue';
import FillLoader from '@ui/atoms/FillLoader.vue';
import Loader from '@ui/atoms/Loader.vue';
import Numberer from '@ui/atoms/Numberer.vue';
import History from '@ui/atoms/History.vue';

const ValueOrVariable = () => import(/* webpackChunkName: "edit" */ '@ui/molecules/ValueOrVariable.vue');
const ValueOrVariableWithLabel = () => import(/* webpackChunkName: "edit" */ '@ui/molecules/ValueOrVariableWithLabel.vue');
import ComponentCondensedEditButton from '@ui/atoms/ComponentCondensedEditButton.vue';

Vue.component('pbc-button', PbcButton);
Vue.component('pbc-confirmation', PbcConfirmation);
Vue.component('pbc-popup', PbcPopup);
Vue.component('pbc-error', PbcError);
Vue.component('pbc-panel', PbcPanel);
Vue.component('pbc-toggle-button', PbcToggleButton);
Vue.component('toggle-switch', ToggleSwitch);
Vue.component('pbc-modal', PbcModal);
Vue.component('pbc-overlay', PbcOverlay);
Vue.component('loading', Loading);
Vue.component('fill-loader', FillLoader);
Vue.component('loader', Loader);
Vue.component('numberer', Numberer);
Vue.component('history', History);
Vue.component('value-or-variable', ValueOrVariable);
Vue.component('value-or-variable-with-label', ValueOrVariableWithLabel);
Vue.component('component-condensed-edit-button', ComponentCondensedEditButton);


const PropertyForm = () => import(/* webpackChunkName: "edit" */ '@ui/organisms/PropertyForm.vue');
Vue.component('PropertyForm', PropertyForm)
const VueFormGenerator = () => import(/* webpackChunkName: "edit" */ 'vue-form-generator').then( ({component})  => {
  return component;
});
Vue.component('vue-form-generator', VueFormGenerator);
const Multiselect = () => import(/* webpackChunkName: "edit" */ 'vue-multiselect');
Vue.component('multiselect', Multiselect);

// TODO: this makes the main bundle pretty big :-(
import {getOperationAST} from 'graphql';
import VueApollo from 'vue-apollo';
import { createWebsocketLink, createAnonymousWebsocketLink, createAnonymousHttpLink, createUserpoolHttpLink } from './apollo.js'
import { ApolloLink } from 'apollo-link';
import ApolloLinkTimeout from 'apollo-link-timeout';
const timeoutLink = new ApolloLinkTimeout(14 * 1000);
import { createHttpLink } from 'apollo-link-http';
import ApolloClient from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { persistCache } from 'apollo-cache-persist';


//import appSyncPublicConfig from '@/AppSyncPublic.json';
import getAppsyncConfig from './appsyncConfig.js';
const appSyncPublicConfig = getAppsyncConfig();
// especially this POS
//require('amazon-cognito-js');

//const AUTH_DOMAIN = 'auth.triviaboom.com';
const AUTH_DOMAIN = process.env.VUE_APP_COGNITO_AUTH_DOMAIN;
const USER_POOL_ID = process.env.VUE_APP_USERPOOL;
const USER_POOL_WEB_CLIENT_ID = process.env.VUE_APP_COGNITO_APP_CLIENT_ID;
const USER_POOL_REDIRECT = process.env.VUE_APP_USERPOOL_REDIRECT;
const IDENTITY_POOL_ID = process.env.VUE_APP_IDENTITY_POOL;
const REGION = 'eu-west-1';


/*
const region = 'eu-west-1';
const {UserPool, IdentityPool} = appSyncPublicConfig;
const poolId = `cognito-idp.${region}.amazonaws.com/${UserPool}`;
//const identityPoolId = 'eu-west-1:be53e129-77f0-4aaa-85a8-691bd3443039';
const Logins = {};
Logins[poolId] = undefined;
AWS.config.region = region;
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
IdentityPoolId:IdentityPool,
Logins
});
*/


// https://aws-amplify.github.io/docs/js/authentication#manual-setup
Auth.configure({
    //Auth: {
        // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
        identityPoolId: IDENTITY_POOL_ID,
        
        // REQUIRED - Amazon Cognito Region
        region: REGION,

        // OPTIONAL - Amazon Cognito Federated Identity Pool Region 
        // Required only if it's different from Amazon Cognito Region
        //identityPoolRegion: 'XX-XXXX-X',

        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: USER_POOL_ID,

        // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
        userPoolWebClientId: USER_POOL_WEB_CLIENT_ID,

        // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
        mandatorySignIn: false,

        // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
        //authenticationFlowType: 'REFRESH_TOKEN_AUTH',

         // OPTIONAL - Hosted UI configuration
        oauth: {
            domain: AUTH_DOMAIN,
            scope: ['openid', 'profile', 'email'],
                    //"openid",
        //"profile",
            redirectSignIn: USER_POOL_REDIRECT,
            redirectSignOut: USER_POOL_REDIRECT,
            responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
        }
    //}
});
Vue.use({
  install: function install (Vue) {
    Vue.mixin({
    beforeMount() {
      this.$amplify = {
        Hub,
        Auth
      }
    }
    });
  }
});
//Vue.use(AmplifyPlugin, {Auth,I18n,Logger,Hub})

async function createApolloProvider(eventbus, store) {
  let isAuthed = false;

  const isServer = !process.browser;
  if (!isServer) {
    eventbus.on('authed', () => {
      isAuthed = true;
    });
  }
  const url = appSyncPublicConfig.AppSyncEndpoint;
  const proxyUrl = appSyncPublicConfig.AppSyncEndpointProxy;

  const typeDefs = gql`
  type Item {
    id: ID!
    text: String!
    done: Boolean!
  }

  type LocalMeme {
    id: String!
    title: String!
    game: String!
    op: String!
    parent: String!
  }
  type PostDraft {
    id: String!
    created: String!
    updated: String!
    title: String!
    gamedata: String!
    parentId: String!
    opId: String!
  }

  type Mutation {
    addLocalMeme(id: String!, title: String!, game: String!, op: String!, parent: String!): LocalMeme,

    deleteLocalMeme(id: String!): Boolean,

    addItem(text: String!): Item,

    savePostDraft(id: String!, created: String!, updated:String!, title: String!, gamedata: String!, parentId: String!, opId: String!): PostDraft
    deletePostDraft(id: String!): Boolean
  }
`;
  const cache = new InMemoryCache({
    resultCaching: !isServer,
    freezeResults: true
  })

  let data;
  console.log(' am here lol');

  const httpLink = createHttpLink({ uri: proxyUrl });

  const anonymousAuth = {
    type: 'API_KEY',
    //apiKey: 'da2-qoqxcjtwlbgrvjc5hv76eb72iy'
    apiKey: process.env.VUE_APP_API_KEY
  }
  const getJwtToken = () => {
    return store.getters.jwtToken;
  }
  /*
  // TODO: this doesnt seem to work
  // doesnt create the key correctly and always tries to connect.
  // even if user is anonymous
  let userPoolWebsocketLink;
  if (process.browser) {
    userPoolWebsocketLink = createWebsocketLink(url, url, getJwtToken);
  }
  */
  let anonymousWebsocketLink;
  if (process.browser) {
    anonymousWebsocketLink = createAnonymousWebsocketLink(url, url, anonymousAuth.apiKey);
  }
  /*
  const userPoolLink = ApolloLink.from([
    createAuthLink({ url:proxyUrl, region, auth: userPoolAuth }),
    httpLink,
    userPoolWebsocketLink
  ]);
  */

  /*
  const anonymousLink = ApolloLink.from([
    createAuthLink({ url:proxyUrl, region, auth: anonymousAuth }),
    httpLink,
    anonymousWebsocketLink
  ]);
  */
  const tt = createUserpoolHttpLink(url, getJwtToken);
  const userPoolHttpLink = ApolloLink.from([
    timeoutLink,
    tt,
    httpLink,
  ]);

  const t = createAnonymousHttpLink(url, anonymousAuth.apiKey);
  const anonymousHttpLink = ApolloLink.from([
    timeoutLink,
    t,
    httpLink
  ]);

  const anonymousLink = process.browser ? ApolloLink.split(
    (operation) => {
      const operationAST = getOperationAST(operation.query, operation.operationName);
      return !!operationAST && operationAST.operation === 'subscription'
    },
    anonymousWebsocketLink,
    anonymousHttpLink
  ) : anonymousHttpLink;

  const userPoolLink = process.browser ? ApolloLink.split(
    (operation) => {
      const operationAST = getOperationAST(operation.query, operation.operationName);
      return !!operationAST && operationAST.operation === 'subscription'
    },
    anonymousWebsocketLink, // TODO: fix userPoolWebsocketLink and then this should use that?
    userPoolHttpLink
  ) : userPoolHttpLink;

  const link = ApolloLink.split(
    () => {
      return isAuthed;
    },
    userPoolLink,
    anonymousLink,
  )

  //newLinkj
  const defaultClient = new ApolloClient({
    link,
    cache,
    ...(isServer ? {
      // Set this on the server to optimize queries when SSR
      ssrMode: true,
    } : {
      // This will temporary disable query force-fetching
      // NB: this is a very fragile setting. setting this too low causes rehydration issues
      // which causes the whole vue client to abort startup.
      // https://github.com/apollographql/apollo-client/issues/4814
      // https://github.com/quasarframework/app-extension-apollo/issues/34 :-(
      ssrForceFetchDelay: 1100, // TODO: HACK: Is this really the best the apollo community could come up with?!?
    })
  });

  const localCache = new InMemoryCache()
  if (!isServer) {
    const persistedCache = await persistCache({
      cache: localCache,
      storage: !isServer ? window.localStorage : undefined,
      maxSize: 1 * 1048576
    });
  }
  if (process.browser) {
    try {
      console.log('am datas lo');
      data = localCache.readQuery({ query: getPostDraftsQuery });
      console.log('amed data lols');
    } catch (e) {
    }
    if (!data || !data.postDrafts) {
      localCache.writeData({
        data: {
          postDrafts: [
          ],
        },
      });
    }
    try {
      console.log('222 am datas lo');
      data = localCache.readQuery({ query: getLocalMemes });
      console.log('222 amed data lols', data);
    } catch (e) {
    }
    if (!data || !data.localMemes) {
      localCache.writeData({
        data: {
          localMemes: [
          ],
        },
      });
    }
  }

  //const drafts = localCache.readQuery({ query: getPostDraftsQuery });

  const resolvers = {
    Mutation:{
      addLocalMeme: (_, {id, title, game, op, parent}, { cache }) => {
        console.log('add local mememe?!?!?!');
        const data = cache.readQuery({ query: getLocalMemes });
        const newItem = {
          __typename: 'LocalMeme',
          id,
          title,
          game,
          op,
          parent
        }
        data.localMemes.push(newItem);
        cache.writeQuery({query: getLocalMemes, data });
        return newItem;
      },
      deleteLocalMeme(_, {id}, { cache }) {
        const data = cache.readQuery({ query: getLocalMemes });
        const existingIndex = data.localMemes.findIndex( (post) => {
          return post.id === id;
        });
        data.localMemes.splice(existingIndex, 1);
        cache.writeQuery({query: getLocalMemes, data });
        return true;
      },
      savePostDraft: (_, {id, created, updated, title, gamedata, parentId, opId}, { cache }) => {
        const data = cache.readQuery({ query: getPostDraftsQuery });
        const existing = data.postDrafts.find( (post) => {
          return post.id === id;
        });
        if (existing) {
          existing.updated = updated;
          existing.title = title;
          existing.gamedata = gamedata;
          cache.writeQuery({query: getPostDraftsQuery, data });
          return existing;
        } else {
          const newItem = {
            __typename: 'PostDraft',
            id,
            created,
            updated,
            title,
            gamedata,
            parentId,
            opId
          }
          data.postDrafts.push(newItem);
          cache.writeQuery({query: getPostDraftsQuery, data });
          return newItem;
        }
      },
      deletePostDraft(_, {id}, { cache }) {
        const data = cache.readQuery({ query: getPostDraftsQuery });
        const existingIndex = data.postDrafts.findIndex( (post) => {
          return post.id === id;
        });
        data.postDrafts.splice(existingIndex, 1);
        cache.writeQuery({query: getPostDraftsQuery, data });
        return true;
      }

    },

  }
  const localClient = new ApolloClient({
    cache: localCache,
    typeDefs,
    resolvers
  })


      /*
  const apolloClientPublic = new AWSAppSyncClient({
    url: appSyncPublicConfig.AppSyncEndpoint,
    disableOffline: true,
    apiUrl: appSyncPublicConfig.AppSyncEndpoint,
    region: appSyncPublicConfig.region,
    auth: {
      type: appSyncPublicConfig.authenticationType,
      credentials() {
        if (AWS.config.credentials && AWS.config.credentials.identityId) {
          return AWS.config.credentials;
        }

        return new Promise( (resolve, reject) => {
          AWS.config.credentials.refresh( () => {
            console.log('credentials for', AWS.config.credentials.identityId);
            resolve(AWS.config.credentials);
          });
        });

      }
    }
  });
  */

  const apolloProvider = new VueApollo({
    defaultClient: defaultClient,
    clients: {
      localClient,
      defaultClient
    },
  });
  return {apolloProvider,cache};
}

const eventbus = new EventEmitter();
Vue.prototype.$eventbus = eventbus;


/*
import * as VueSegmentTracker from 'vue-segment-tracker'

Vue.use(VueSegmentTracker, {
  key: process.env.VUE_APP_SEGMENT_KEY,
  mixinName: '$segment', // how the mixin is will be call, default: '$segment'
  directiveName: 'segment', // how the mixin is will be call, default: 'segment'
  // optional options
  options: {
    // default segment options
  },
  routing: {
    vueRouter: router, //  Pass the router instance to automatically sync with router (optional)
    preferredProperty: 'name', // By default 'path' and related with vueRouter (optional)
  },
})
*/

Vue.use(ana);

const createApp = async (context) => {
  // create router and store instances

  const router = createRouter(Vue.prototype.$eventbus);
  const store = createStore();
  const isServer = !process.browser;
  if (!isServer) {
    Vue.use(VueGtag, {
      config: { id: "UA-63300532-31" }
    },router);
  }



  // sync so that route state is available as part of the store
  sync(store, router);

  const {apolloProvider,cache} = await createApolloProvider(eventbus, store);

  const app = new Vue({
    apolloProvider,
    data: { url: context ? context.url : '' },
    router,
    store,
    render: h => h(App),
  });

  return { app, router, store, apolloProvider, cache, Vue };
};

export { createApp };
